import { Form as AntdForm } from 'antd'
import { DateStyles } from 'components/DatePickerStyles/DatePickerStyles'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import styled from 'styled-components'

export const FormItem = styled(AntdForm.Item)`
  margin-bottom: 0px !important;
`
export const Form = styled(AntdForm)`
  row-gap: 20px;
  display: flex;
  flex-direction: column;
`
export const TwoFields = styled(Flex)`
  gap: 20px;
`
export const DivWrapper = styled.div`
  width: 100%;
`
export const DateStylePaper = styled(DateStyles)`
  margin-top: 5px;
  width: 100%;
`
export const StyledInput = styled(Input)`
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
`
